import {
  topBrickVariants,
  bottomBrickVariants,
  middleBrickVariants,
  topBrickClosedVariants,
  bottomBrickClosedVariants,
  brickGroupTransition,
  brickTransition,
} from "./motion";
import { AnimatePresence, motion } from "framer-motion";
import cls from "./styles.module.css";
import { HamburgerConfig as Config } from "./config";
import {
  useAppMenuVisibilityState,
  useCloseAppMenu,
  useOpenAppMenu,
} from "@/hooks/use-app-menu";

const BrickGroupContainer: React.FC<{ children: any }> = (props) => (
  <motion.div
    aria-hidden
    initial="initial"
    animate="animate"
    exit="exit"
    transition={brickGroupTransition}
  >
    {props.children}
  </motion.div>
);
export default function Hamburger() {
  const isOpen = useAppMenuVisibilityState();
  const openAppMenu = useOpenAppMenu();
  const closeAppMenu = useCloseAppMenu();
  const toggle = () => {
    if (isOpen) closeAppMenu();
    else openAppMenu();
  };
  const title = isOpen ? "Закрыть навигацию" : "Открыть навигацию";
  return (
    <motion.button
      aria-label={title}
      title={title}
      onClick={toggle}
      className={cls.root}
      style={{
        width: Config.width,
        height: Config.height,
      }}
    >
      <AnimatePresence initial={false} mode="wait">
        {isOpen ? (
          <BrickGroupContainer key="ham-open">
            <motion.span
              className={cls.closedBrick}
              transition={brickTransition}
              variants={topBrickClosedVariants}
              style={{
                rotateZ: -45,
              }}
            />
            <motion.span
              className={cls.closedBrick}
              transition={brickTransition}
              variants={bottomBrickClosedVariants}
              style={{
                rotateZ: 45,
              }}
            />
          </BrickGroupContainer>
        ) : (
          <BrickGroupContainer key="ham-close">
            <motion.span
              className={cls.topBrick}
              transition={brickTransition}
              variants={topBrickVariants}
            />
            <motion.span
              className={cls.middleBrick}
              transition={brickTransition}
              variants={middleBrickVariants}
            />
            <motion.span
              className={cls.bottomBrick}
              transition={brickTransition}
              variants={bottomBrickVariants}
            />
          </BrickGroupContainer>
        )}
      </AnimatePresence>
    </motion.button>
  );
}
